<section class="about-tanuh" aria-labelledby="about-tanuh-title">
  <div class="about-tanuh__inner">
    <p class="about-tanuh__eyebrow">About TANUH</p>

    <h2 id="about-tanuh-title" class="about-tanuh__title">
      Translational AI for Networked Universal Healthcare
    </h2>

    <div class="about-tanuh__body">
      <p>
        <span class="about-tanuh__line">TANUH (Translational AI for Networked Universal Healthcare) is the AI Centre of Excellence in</span>
        <span class="about-tanuh__line">Healthcare under the Ministry of Education, Government of India, hosted at the Indian Institute of</span>
        <span class="about-tanuh__line">Science (IISc), Bengaluru.</span>
      </p>
      <p>
        <span class="about-tanuh__line">It is dedicated to developing sovereign (i.e., India-specific), clinically validated AI solutions for</span>
        <span class="about-tanuh__line">the country's most pressing healthcare challenges. The focus is on building solutions that</span>
        <span class="about-tanuh__line">support population-based screening for non-communicable diseases.</span>
      </p>
    </div>

    <a
      class="about-tanuh__btn"
      href="https://www.tanuh.ai/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Visit tanuh.ai
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M4.5 11.5 11.5 4.5M6.5 4.5h5v5"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  </div>
</section>
